import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    quote: 'Mis hijos me PIDEN hacer las actividades cada tarde. Increíble.',
    author: 'María G.',
    role: 'mamá de 3 niños',
    flag: '🇲🇽'
  }, {
    quote: 'Finally a bilingual activity book that actually works! My kids love it.',
    author: 'Sarah M.',
    role: 'mom of 2',
    flag: '🇺🇸'
  }, {
    quote: 'Lo imprimí, lo usé ese mismo día. Vale muchísimo más de lo que cuesta.',
    author: 'Carolina R.',
    role: 'mamá de niña de 7 años',
    flag: '🇨🇴'
  }];
  return <section ref={ref} className="w-full bg-white py-16 md:py-20" data-id="element-130">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-131">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} className="font-fredoka text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-12" data-id="element-132">
          Lo que dicen otras mamás...
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-133">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.2 * index,
          duration: 0.6
        }} className="bg-orange-50 p-6 rounded-2xl shadow-lg" data-id="element-134">
              <div className="flex gap-1 mb-4" data-id="element-135">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-orange-400 text-orange-400" data-id="element-136" />)}
              </div>

              <p className="font-nunito text-base text-gray-800 mb-4 italic leading-relaxed" data-id="element-137">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-2" data-id="element-138">
                <span className="text-2xl" data-id="element-139">{testimonial.flag}</span>
                <div data-id="element-140">
                  <p className="font-nunito font-bold text-gray-900 text-sm" data-id="element-141">
                    {testimonial.author}
                  </p>
                  <p className="font-nunito text-xs text-gray-600" data-id="element-142">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}